import { useEffect, useState } from "react";

export function ChatHistory() {
  const [history, setHistory] = useState({});
  const [selectedChat, setSelectedChat] = useState(null);

  useEffect(() => {
    fetch("https://portfolio-bot-eta.vercel.app/")
      .then((res) => res.json())
      .then((data) => {
        setHistory(data);
      })
      .catch((err) => console.error("Error fetching history:", err));
  }, []);




  const deleteAllChats =() =>{
        fetch("https://portfolio-bot-eta.vercel.app/delete", { method: "POST" })
          .then((res) => res.text())
          .then((data) => {
            setHistory({});
            alert(data);
          })
          .catch((err) => alert("Error Delleting chats "));

  }

  return (
    <div className="p-6 fixed top-0 left-0 bg-black h-screen w-screen flex">
      {/* Left Side: Chat List */}
      <div className="w-1/3 bg-gray-800 p-4 overflow-y-auto">
        <div className=" flex justify-between">
          <h1 className=" font-bold mb-4 text-white ">Chat History</h1>
          <button onClick={()=>deleteAllChats()}>Delete All chats</button>
        </div>
        <ul>
          {Object.entries(history).map(([tabId, chatMessages], index) => (
            <li
              key={tabId}
              className="mb-2 p-2 bg-gray-700 rounded cursor-pointer hover:bg-gray-600"
              onClick={() => setSelectedChat(chatMessages)}
            >
              <div className="text-white font-medium">User Id: {index + 1}</div>
              <div className="text-gray-300 text-sm">
                {chatMessages.length > 0
                  ? chatMessages[chatMessages.length - 1].parts[0].text
                  : "No messages"}
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Right Side: Selected Chat Conversation */}
      <div className="w-2/3 bg-gray-900 p-4 overflow-y-auto">
        {selectedChat ? (
          <>
            <h2 className="font-bold mb-4 text-white">Conversation</h2>
            <div className="space-y-4">
              {selectedChat.map(
                (msg, i) =>
                  i !== 0 && (
                    <div
                      key={i}
                      className={`p-3 rounded  ${
                        msg.role === "user" ? "bg-blue-500" : "bg-green-500"
                      }`}
                    >
                      <strong className="text-sm text-white">{msg.role}:</strong>
                      <p className=" text-sm text-white">
                        {msg.parts[0].text}
                      </p>
                    </div>
                  )
              )}
            </div>
          </>
        ) : (
          <div className="text-green-400">
            Select a chat to view the conversation.
          </div>
        )}
      </div>
    </div>
  );
}
